module.exports = __webpack_public_path__ + "img/adv_grant.ee6c0400.png";